package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.px

val ProcessingContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(top = 40.px, bottom = 40.px, leftRight = 30.px)
    }
    Breakpoint.MD {
        Modifier.padding(top = 60.px, bottom = 60.px, leftRight = 60.px)
    }
    Breakpoint.LG {
        Modifier
            .width(620.px)
            .padding(top = 170.px, bottom = 80.px, leftRight = 0.px)
    }
}

val ProcessingTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(22.px)
            .margin(bottom = 30.px)
    }
    Breakpoint.MD {
        Modifier
            .fontSize(26.px)
            .margin(bottom = 40.px)
    }
    Breakpoint.LG {
        Modifier
            .fontSize(30.px)
            .margin(bottom = 50.px)
    }
}

val ProcessingStepsListStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(20.px)
            .margin(bottom = 40.px)
    }
    Breakpoint.MD {
        Modifier
            .gap(25.px)
            .margin(bottom = 50.px)
    }
    Breakpoint.LG {
        Modifier
            .gap(30.px)
            .margin(bottom = 90.px)
    }
}

val ProcessingStepBadgeStyle = CssStyle {
    base { Modifier.size(44.px) }
    Breakpoint.MD { Modifier.size(50.px) }
    Breakpoint.LG { Modifier.size(64.px) }
}

val ProcessingStepNumberStyle = CssStyle {
    base { Modifier.fontSize(16.px) }
    Breakpoint.MD { Modifier.fontSize(18.px) }
    Breakpoint.LG { Modifier.fontSize(32.px) }
}

val ProcessingStepTextStyle = CssStyle {
    base { Modifier.fontSize(14.px) }
    Breakpoint.MD { Modifier.fontSize(16.px) }
    Breakpoint.LG { Modifier.fontSize(18.px) }
}